import { render, staticRenderFns } from "./eItemsReceivedEditDlg.vue?vue&type=template&id=a154888a&"
import script from "./eItemsReceivedEditDlg.vue?vue&type=script&lang=js&"
export * from "./eItemsReceivedEditDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports